import { IAssetClass } from '../../models/i-asset-class';
import { ICompany } from '../../models/i-company';
import { IEtf } from '../../models/i-etf';
import { IFund } from '../../models/i-fund';
import { IInvestmentTrust } from '../../models/i-investment-trust';
import { IManager } from '../../models/i-manager';
import { IPerson } from '../../models/i-person';
import { ISector } from '../../models/i-sector';
import { IShare } from '../../models/i-share';
import { ITag } from '../../models/i-tag';
import { ITopic } from '../../models/i-topic';

export interface IDigitalPublicationSection {
  id: number;
  order: number;
  path?: string;
  name?: string;
  relatedManagers?: IManager[];
  relatedAssetClass?: IAssetClass[];
  relatedSectors?: ISector[];
  relatedFunds?: IFund[];
  relatedEtfs?: IEtf[];
  relatedInvestmentTrusts?: IInvestmentTrust[];
  relatedShares?: IShare[];
  relatedCompanies?: ICompany[];
  relatedPeoples?: IPerson[];
  tags?: ITag[];
  topics?: ITopic[];
}

export class DigitalPublicationSection implements IDigitalPublicationSection {
  constructor(
    public id: number,
    public order: number,
    public name?: string,
    public path?: string,
    public relatedManagers?: IManager[],
    public relatedAssetClass?: IAssetClass[],
    public relatedSectors?: ISector[],
    public relatedFunds?: IFund[],
    public relatedEtfs?: IEtf[],
    public relatedInvestmentTrusts?: IInvestmentTrust[],
    public relatedShares?: IShare[],
    public relatedCompanies?: ICompany[],
    public relatedPeoples?: IPerson[],
    public tags?: ITag[],
    public topics?: ITopic[]
  ) {}
}
